<template>
  <div class="Groups">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md12>
          <v-card class="mb-2">
            <v-card-title class="title">
              Grupos del Proyecto: {{ project.nombre_proyecto }}
              <v-spacer/>

              <v-text-field
                v-if="dataVals !== null"
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer/>

              <!-- <v-card-actions>
                <v-btn color="info" :disabled="dataVals.length === 0">
                  <download-csv
                    :data="dataVals"
                    :name="''"
                    :labels="labelsTotal"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions> -->

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="info" dark class="mb-2" v-on="on">Nuevo Grupo</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form
                      ref="form"
                      v-model="form"
                    >
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="editedGroup.nombre_grupo"
                            label="Nombre Grupo*"
                            :rules="nameRules"
                            counter="20"
                            required
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="editedGroup.fecha_creacion"
                            label="Fecha de Creación*"
                            type="date"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <small>* Campos obligatorios</small>
                  </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="info" @click="close">Cancelar</v-btn>
                    <v-btn
                      :disabled="!form"
                      color="success"
                      @click="save"
                    >Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-data-table
              dense
              :headers="headers"
              :items="dataVals"
              :search="search"
              no-results-text="No se encontro el término buscado"
              no-data-text="No hay datos disponibles"
              multi-sort
              class="elevation-1"
              loading="Cargando... Por favor espere."
              :key="tableGroupKey"
            >
              <template slot="items" slot-scope="props">
                <td v-for="col in columns" :key="col.id">{{ props.item[col] }}</td>
                <td class="justify-center layout px-0">
                  <v-icon
                    color="info"
                    @click="editGroup(props.item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    color="error"
                    @click="deleteGroup(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>

            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Eliminar Grupo</span>
                </v-card-title>
                <v-card-text>
                  Seguro que quiere eliminar el grupo: <br>
                  <span class="title">
                    {{ editedGroup.nombre_grupo }}
                  </span> <br>
                  Esta acción no se puede deshacer
                  <v-checkbox
                    v-model="checkbox"
                    label="Confirmo que deseo eliminar los datos del grupo"
                  ></v-checkbox>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="info" @click="close">Cancelar</v-btn>
                  <v-btn
                    color="error"
                    @click="byeGroup"
                    :disabled="!checkbox"
                  >Eliminar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>

          <pretty-json
            :data="editedGroup"
          ></pretty-json>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import JsonPretty from 'vue-json-pretty'
// import JsonCSV from 'vue-json-csv'

export default {
  name: `Groups`,

  components: {
    // 'download-csv': JsonCSV,
    'pretty-json': JsonPretty
  },

  /** Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.project = this.$store.state.actualProject
    this.getGroups()
  },

  data: function () {
    return {
      backConf: {
        pathList: '/core/groups/?page=',
        pathCUD: '/core/groups/', // Post sin documento demas con documento
        page: 1
      },

      project: null,

      progressSize: 70,
      progressWidth: 7,

      loading: false,
      form: false,
      checkbox: false,

      headers: [
        // {
        //   text: 'Identificador',
        //   align: 'left',
        //   value: 'id'
        // },
        { text: 'Nombre Grupo', value: 'nombre_grupo', align: 'left' },
        { text: 'Fecha Creación', value: 'fecha_creacion' },
        { text: 'Acciones', value: '', align: 'left', sortable: false }
      ],
      dataVals: [],
      defaultGroup: {
        'nombre_grupo': '',
        'fecha_creacion': new Date().toISOString().substr(0, 10)
      },
      tableGroupKey: 0,

      search: '',
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedGroup: {
        'nombre_grupo': '',
        'fecha_creacion': new Date().toISOString().substr(0, 10)
      },

      nameRules: [
        v => !!v || 'Se requiere nombre de grupo',
        v => (v.length < 21) || 'Maximo 20 caracteres'
      ]
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  computed: {
    /** Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })

      colVals.pop() // remueve la columna final, para alinear los iconos
      return colVals
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Grupo' : 'Editar Grupo'
    }
  },

  methods: {
    /** Carga la información de todos los grupos
     */
    getGroups () {
      this.loading = true
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.pathList + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getGroups()
          } else {
            t.backConf.page = 1
            t.loading = false
          }
        })
        .catch(err => console.error(err))

      t.tableGroupKey += 1
    },

    /** Carga los datos del grupo seleccionado y abre el dialog
     * @param  {Object} group El grupo a editar
     */
    editGroup (group) {
      this.editedIndex = this.dataVals.indexOf(group)
      this.editedGroup = Object.assign({}, group)
      this.dialog = true
    },

    /** Carga los datos del grupo seleccionado y abre el dialog
     * @param  {Object} group El grupo a eliminar
     */
    deleteGroup (group) {
      this.editedIndex = this.dataVals.indexOf(group)
      this.editedGroup = Object.assign({}, group)
      this.dialogDelete = true
    },

    /** Elimina el usaurio seleccionado, previa confirmación
     * actualiza la tabla local
     */
    byeGroup () {
      let request = {
        method: 'delete',
        data: {},
        url: this.backConf.pathCUD + this.editedGroup.id + '/'
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals.splice(t.editedIndex, 1)
          t.close()
        })
        .catch(err => console.error(err))
    },

    /** Limpia el formulario de grupo y setea el index del elemento
     */
    close () {
      this.dialog = false
      this.dialogDelete = false
      setTimeout(() => {
        this.editedGroup = Object.assign({}, this.defaultGroup)
        this.editedIndex = -1
      }, 300)
    },

    /** Guarda la información del grupo,
     * sea un grupo nuevo o una actualización
     * actualiza la tabla local
     */
    save () {
      let request = {
        method: this.editedIndex > -1 ? 'put' : 'post',
        data: this.editedGroup,
        url: this.editedIndex > -1 ? this.backConf.pathCUD + this.editedGroup.id + '/' : this.backConf.pathCUD
      }
      console.log('method', request.method)
      console.log('data', JSON.stringify(request.data))
      console.log('url', request.url)

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (t.editedIndex > -1) {
            Object.assign(t.dataVals[t.editedIndex], t.editedGroup)
          } else {
            t.dataVals.push(t.editedGroup)
          }
          t.close()
        })
        .catch(err => console.error(err))
    }
  }
}
</script>
